import { FC } from 'react';
import Logo from 'src/assets/images/logo.png';
import { media } from 'src/common/styles/breakpoints';
import styled, { css } from 'styled-components';
import { typography } from 'src/common/styles/typography';
import { FormattedMessage } from 'react-intl';

const StyledLogoFooter = styled.div`
  width: 7.5rem;
  height: 2.8125rem;

  img {
    width: 100%;
  }
`;

const Annotations = styled.div`
  display: flex;
  flex-direction: column;
  align-items: baseline;
  gap: 3.9375rem;
  width: 100%;
  grid-area: annotation;
  ${media.w.min.px576(css`
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-end;
  `)}
`;

const Copyright = styled.p`
  color: ${({ theme }) => theme.text.primary};
  font-family: ${typography.fontFamilyDefault};
  opacity: 0.4;
  font-size: 0.8125rem;
`;

const FooterAnnotations: FC = () => {
  return (
    <Annotations>
      <StyledLogoFooter>
        <img src={Logo} alt="AIS Gateway" />
      </StyledLogoFooter>
      <Copyright>
        &copy; {new Date().getFullYear()}{' '}
        <FormattedMessage id="footer.allRightsReserved" /> AIS Gateway
      </Copyright>
    </Annotations>
  );
};

export default FooterAnnotations;
